/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'network-security-policy';
const componentName = 'network-security-policy-list';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const columnTitleName = `${prefix}.columnTitleName`;
export const columnTitleTotalNetworkSecurityRules = `${prefix}.columnTitleTotalNetworkSecurityRules`;
export const gridPlaceholder = `${prefix}.gridPlaceholder`;

export const ENGLISH = {
    [headerLabel]: 'Network Security Policy',
    [columnTitleName]: 'Name',
    [columnTitleTotalNetworkSecurityRules]: '# Network Security Rules',
    [gridPlaceholder]: 'No Items Found',
};
